import React, { useState, useEffect } from 'react';
import api from '../api';
import { Clock } from 'lucide-react';
import ModeratorNavbar from './ModeratorNavbar';
import './ModeratorDashboard.css';

const ModeratorActions = ({ onLogout }) => {
  const [recentActions, setRecentActions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadActions();
  }, []);

  const loadActions = async () => {
    setLoading(true);
    setError('');
    
    try {
      const response = await api.get('/api/moderator/actions?limit=50');
      setRecentActions(response.data.actions || response.data || []);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load moderator actions');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="moderator-shell">
      <ModeratorNavbar onLogout={onLogout} />

      {error && <div className="mod-alert">{error}</div>}

      <div className="moderator-content">
        <h2 className="section-title">My Moderation Activity</h2>
        
        {loading ? (
          <div className="loading">Loading action history...</div>
        ) : (
          <div className="actions-list">
            {recentActions.length === 0 ? (
              <div className="no-reports">No moderation actions found</div>
            ) : (
              recentActions.map(action => (
                <div key={action.id} className="action-card">
                  <div className="action-header">
                    <span className={`action-type ${action.actionType}`}>
                      {action.actionType.replace(/_/g, ' ').toUpperCase()}
                    </span>
                    <span className="action-date">
                      <Clock size={14} />
                      {new Date(action.timestamp).toLocaleString()}
                    </span>
                  </div>
                  <div className="action-details">
                    {action.details?.targetUserName && (
                      <p><strong>User:</strong> {action.details.targetUserName}</p>
                    )}
                    {action.details?.reason && (
                      <p><strong>Reason:</strong> {action.details.reason}</p>
                    )}
                    {action.details?.customMessage && (
                      <p><strong>Message:</strong> {action.details.customMessage}</p>
                    )}
                    {action.details?.reportId && (
                      <p><strong>Report ID:</strong> {action.details.reportId}</p>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ModeratorActions;
